// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoUnavailable-cls1_-Ve","cls2":"VideoUnavailable-cls2_TmH VideoUnavailable-cls1_-Ve"};